// styles
import { HeroWrapper } from './Hero.styles';

export function Hero() {
  return (
    <HeroWrapper
      bg={{
        xxlarge: 'images/shipper/hero/loadsmart-hero-xxlg@2x.jpg',
        large: 'images/shipper/hero/loadsmart-hero-xxlg@2x.jpg',
        medium: 'images/shipper/hero/loadsmart-hero-xxlg@2x.jpg',
        small: 'images/shipper/hero/loadsmart-hero-small@2x.jpg',
      }}
    />
  );
}
